/**************************************************************************
 * Created on Mon Nov 04 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/
import React from 'react';
import { ToastContainer, toast, TypeOptions, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export interface ISnackbar {
    message?: string;
    type: TypeOptions;
    onClose?: () => void;
    duration?: number;
}

export const DLSSnackbar = () => {


    return (

        <ToastContainer
            position="top-right"
        />


    )

}


const _notify = (props: ISnackbar) => {
    const options: ToastOptions = {
        pauseOnHover: true,
        autoClose: props.duration ?? 5000,
        type: props.type,
        closeButton: true,
        onClose:props.onClose

    }


    return toast(props.message ?? '', options);
}

/**
 * 
 * @param props:ISnackbar  
 * @deprecated This method is depricated Rathar use notifyError,notifyDefault,notifySuccess,notifyInfo,notifyWarning instead.
 * @returns 
 */


export const notify = (props: ISnackbar) => {
    const options: ToastOptions = {
        pauseOnHover: true,
        autoClose: props.duration ?? 5000,
        type: props.type,
        closeButton: true
    }


    return toast(props.message ?? '', options);
}


/**
 * 
 * @param message message to display
 * @param duration Optional Integer to display time(millis) of notification bar. Default is 5000 5s 
 * @returns 
 */


export const notifyDefault = (message: NonNullable<unknown>, duration?: number) => {
    return _notify({ type: 'default', message: (message ?? '').toString(), duration })

}
/**
 * 
 * @param message message to display
 * @param duration Optional Integer to display time(millis) of notification bar. Default is 5000 5s 
 * @returns 
 */


export const notifyError = (message: NonNullable<unknown>, duration?: number,onClose?:()=>void) => {
    return _notify({ type: 'error', message: (message ?? '').toString(), duration,onClose })
}
/**
 * 
 * @param message message to display
 * @param duration Optional Integer to display time(millis) of notification bar. Default is 5000 5s 
 * @returns 
 */


export const notifySuccess = (message: NonNullable<unknown>, duration?: number,onClose?:()=>void) => {
    return _notify({ type: 'success', message: (message ?? '').toString(), duration,onClose })
}
/**
 * 
 * @param message message to display
 * @param duration Optional Integer to display time(millis) of notification bar. Default is 5000 5s 
 * @returns 
 */


export const notifyInfo = (message: NonNullable<unknown>, duration?: number,onClose?:()=>void) => {
    return _notify({ type: 'info', message: (message ?? '').toString(), duration,onClose })
}

/**
 * 
 * @param message message to display
 * @param duration Optional Integer to display time(millis) of notification bar. Default is 5000 5s 
 * @returns 
 */


export const notifyWarning = (message: NonNullable<unknown>, duration?: number,onClose?:()=>void) => {
    return _notify({ type: 'warning', message: (message ?? '').toString(), duration,onClose })
}
